export const environment = {
  production: true,
  subscriptionKey: '1422f5ddf5004e54a3e9370dfb47af75',
  googleAnalytics: "G-36PNSY65TZ",
  api: 'https://true-style-guide-svc.truehomesusa.com',
  imageBaseUrl: 'https://truehomesprodstorage.blob.core.windows.net/optionfullsize/',
  thumbnailBaseUrl: 'https://truehomesprodstorage.blob.core.windows.net/optionthumbnails/',
  bingImageSearchEndpoint: 'https://api.bing.microsoft.com/v7.0/images/search',
  showDebugLabels: false,
  userProfileImage: 'https://truehomesprodstorage.blob.core.windows.net/userimage/',
  surveyLink: 'https://forms.office.com/r/VArqDm7Aek',
  theme:
  {
    loadingBackgroundColor: '#616164',
    primaryColor: '#f68428',
    secondaryColor: '#ffeb3b',
    focusedAlpha: .99,
    unfocusedAlpha: .8,

    // Logos for the canvas interface
    loadingLogoUrl: '/assets/images/theme/large_u.svg',
    logo: '/assets/images/theme/bottom_logo.svg',
    favoriteIcon: '/assets/images/ui-icons/heart.svg',
    unfavoriteIcon: '/assets/images/ui-icons/heart-unselected.svg',
    infoIcon: '/assets/images/ui-icons/info-icon.svg',
    btnFavoriteIcon: '/assets/images/ui-icons/btn-heart.svg',
    btnUnfavoriteIcon: '/assets/images/ui-icons/btn-heart-unselected.svg',
    tagIcon: '/assets/images/ui-icons/home-heart.svg',
    flipIcon: '/assets/images/ui-icons/exchange-icon.svg',
    trashIcon: '/assets/images/ui-icons/trash-can-solid.svg',
    trashDisabledIcon: '/assets/images/ui-icons/trash-can-solid.svg',
    newOptionIcon: '/assets/images/theme/loading_small.gif',
    backIcon: '/assets/images/ui-icons/back.svg',
    defaultSCImage: '/assets/images/default_consultant_image.png'
  },
  collectionColors:
  {
    default: "#41b08b",
    elements: "#41b08b",
    elementsPremiere: "#41b08b",
    integrity: "#49a2c5",
    tribute: "#1e86cf",
    traditions: "#e2a756",
    uptownLiving: "#514c7d",
    answer: "#BE202E"
  },
  collectionImageBaseUrl: "/assets/images/collections/"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
